import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

export const deleteQuote = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();

  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    defaultOnMutateSettled,
  } = useAPQuery();

  return useMutation({
    mutationFn: (quoteId: string): Promise<boolean> => {
      return fetchWithAuth<boolean>("deleteQuote", quoteId, {
        requestOptions: { method: "delete" },
      });
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
    onSettled: (data, error, quoteId) => {
      const invalidateList = [];
      const removeList = [
        ["list-quote", quoteId],
        ["quote", quoteId],
        ["quote-vehicle-suggestions", quoteId],
        ["quote-vehicle-images", quoteId],
        ["quote-vehicle-info", quoteId],
        ["quote-calculations", quoteId],
        ["quote-finance-comparison-calculations", quoteId],
        ["quote-finance-comparison", quoteId],
      ];

      if (dossierId) {
        invalidateList.push(
          ["quotes", dossierId],
          ["dossier", dossierId],
          ["quotes-with-specs", dossierId]
        );
      }

      defaultOnMutateSettled(invalidateList, removeList);
    },
  });
};
